module.exports = __webpack_public_path__ + "static/media/truck_blue.e69c8b99.svg";